export type NikeSizeRow = { eu: number; cm: number };

export const nikeSizeTable: NikeSizeRow[] = [
  { eu: 35.5, cm: 21.6 },
  { eu: 36, cm: 22.0 },
  { eu: 36.5, cm: 22.4 },
  { eu: 37.5, cm: 22.9 },
  { eu: 38, cm: 23.3 },
  { eu: 38.5, cm: 23.7 },
  { eu: 39, cm: 24.1 },
  { eu: 40, cm: 24.5 },
  { eu: 40.5, cm: 25.0 },
  { eu: 41, cm: 25.4 },
  { eu: 42, cm: 25.8 },
  { eu: 42.5, cm: 26.2 },
  { eu: 43, cm: 26.7 },
  { eu: 44, cm: 27.1 },
  { eu: 44.5, cm: 27.5 },
  { eu: 45, cm: 27.9 },
  { eu: 45.5, cm: 28.3 },
  { eu: 46, cm: 28.8 },
  { eu: 47, cm: 29.2 },
  { eu: 47.5, cm: 29.6 },
  { eu: 48, cm: 30.0 },
  { eu: 48.5, cm: 30.5 },
  { eu: 49, cm: 30.9 },
  { eu: 49.5, cm: 31.3 },
  { eu: 50, cm: 31.7 },
  { eu: 50.5, cm: 32.2 },
  { eu: 51, cm: 32.6 },
  { eu: 51.5, cm: 33.0 },
  { eu: 52, cm: 33.4 },
  { eu: 52.5, cm: 33.9 },
  { eu: 53, cm: 34.3 },
  { eu: 53.5, cm: 34.7 },
  { eu: 54, cm: 35.1 },
  { eu: 54.5, cm: 35.5 },
  { eu: 55, cm: 36.0 },
  { eu: 55.5, cm: 36.4 },
  { eu: 56, cm: 36.8 },
  { eu: 56.5, cm: 37.2 },
];
